(function () {
  'use strict';

  const DEBUG_POPUP = false;

  const API = 'https://loyalty-program-pi.vercel.app/api/popup';
  let POPUP_ID = null; // id de la popup affichée — permet des stats séparées par popup

  const JOINED_KEY  = 'eut_popup_joined';   // permanent — a cliqué le CTA
  const SESSION_KEY = 'eut_popup_session';  // session — a fermé la popup cette visite
  const ATTRIBUTION_KEY = 'eut_popup_clicked';

  function getSessionId() {
    let id = localStorage.getItem('eut_popup_sid');
    if (!id) {
      id = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2);
      localStorage.setItem('eut_popup_sid', id);
    }
    return id;
  }

  function hasJoined()          { return !!localStorage.getItem(JOINED_KEY); }
  function dismissedThisSession(){ return !!sessionStorage.getItem(SESSION_KEY); }
  function markJoined()         { localStorage.setItem(JOINED_KEY, '1'); }
  function markSessionDismiss() { sessionStorage.setItem(SESSION_KEY, '1'); }
  function markAttribution()    { localStorage.setItem(ATTRIBUTION_KEY, '1'); }

  function trackEvent(event_type) {
    const customerId = window.__st?.cid ? String(window.__st.cid) : null;
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        mode: 'event',
        event_type,
        popup_id: POPUP_ID,
        session_id: getSessionId(),
        shopify_customer_id: customerId,
        page_url: location.pathname,
      }),
      keepalive: true,
    }).catch(() => {});
  }

  function injectStyles() {
    if (document.getElementById('eut-popup-style')) return;
    const style = document.createElement('style');
    style.id = 'eut-popup-style';
    style.textContent = `
      #eut-popup-overlay {
        position: fixed;
        inset: 0;
        background: rgba(21, 21, 21, 0.55);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        animation: eut-fade-in 0.3s ease;
      }
      @media (hover: hover) and (pointer: fine) {
        #eut-popup-overlay {
          cursor: var(--cursor-close-svg-url) 26 26, pointer;
        }
      }
      @keyframes eut-fade-in {
        from { opacity: 0; }
        to   { opacity: 1; }
      }
      #eut-popup-card {
        background: #fff;
        border-radius: 16px;
        overflow: hidden;
        width: min(100%, 400px);
        position: relative;
        box-shadow: 0 24px 80px rgba(0,0,0,0.22);
        animation: eut-slide-up 0.35s cubic-bezier(0.19, 1, 0.22, 1);
        cursor: default;
      }
      @keyframes eut-slide-up {
        from { opacity: 0; transform: translateY(24px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      #eut-popup-img-wrap {
        position: relative;
        display: block;
      }
      #eut-popup-img {
        width: 100%;
        aspect-ratio: 16/10;
        object-fit: cover;
        display: block;
        background: #f0f0f0;
      }
      #eut-popup-img-badge {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #fff;
        pointer-events: none;
      }
      #eut-popup-img-badge svg {
        width: 22px;
        height: auto;
        filter: drop-shadow(0 2px 6px rgba(0,0,0,0.45));
        flex-shrink: 0;
      }
      #eut-popup-img-badge span {
        font-family: 'Bicyclette', 'Helvetica Neue', sans-serif;
        font-size: 1rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        text-shadow: 0 2px 6px rgba(0,0,0,0.45);
      }
      #eut-popup-close {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: rgba(255,255,255,0.9);
        border: none;
        cursor: pointer;
        font-size: 16px;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #151515;
        z-index: 2;
        padding: 0;
      }
      #eut-popup-close:hover { background: #fff; }
      #eut-popup-body {
        padding: 28px 24px 24px;
        text-align: center;
      }
      #eut-popup-title {
        font-family: 'Bicyclette', 'Helvetica Neue', sans-serif;
        font-size: 1.2rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        color: #151515;
        margin-bottom: 10px;
        line-height: 1.25;
      }
      #eut-popup-subtitle {
        font-family: 'Bricolage Grotesque', 'Helvetica Neue', sans-serif;
        font-size: 0.88rem;
        color: #666;
        line-height: 1.55;
        margin-bottom: 20px;
      }
      #eut-popup-cta {
        display: block;
        width: 100%;
        box-sizing: border-box;
        border: 0;
        cursor: pointer;
        background: #151515;
        color: #fff;
        font-family: 'Bicyclette', 'Helvetica Neue', sans-serif;
        font-size: 0.82rem;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        text-decoration: none;
        text-align: center;
        padding: 14px 20px;
        border-radius: 8px;
        transition: opacity 0.2s;
      }
      #eut-popup-cta:hover { opacity: 0.82; color: #fff; }
      @media (max-width: 480px) {
        #eut-popup-overlay { padding: 20px; align-items: center; }
        #eut-popup-card { width: 100%; border-radius: 16px; }
      }

      /* ── Mode capture email ── */
      #eut-popup-form {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 4px;
      }
      #eut-popup-email {
        width: 100%;
        box-sizing: border-box;
        padding: 14px 16px;
        border: 1px solid #dcdcdc;
        border-radius: 999px;
        /* 16px imperatif : en dessous, iOS zoome sur le champ au focus */
        font-size: 16px;
        font-family: inherit;
        color: #151515;
        text-align: center;
        outline: none;
        transition: border-color 0.15s ease;
      }
      #eut-popup-email::placeholder { color: #b5b5b5; }
      #eut-popup-email:focus { border-color: #151515; }
      #eut-popup-email[aria-invalid="true"] { border-color: #e11d2a; }
      #eut-popup-submit {
        width: 100%;
        padding: 15px 16px;
        border: 0;
        border-radius: 999px;
        background: #151515;
        color: #fff;
        font-family: inherit;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
        transition: opacity 0.15s ease;
      }
      #eut-popup-submit:disabled { opacity: 0.55; cursor: default; }
      #eut-popup-error {
        color: #e11d2a;
        font-size: 12px;
        line-height: 1.4;
      }
      #eut-popup-error:empty { display: none; }
      #eut-popup-consent {
        font-size: 11px;
        line-height: 1.45;
        color: #9a9a9a;
      }
    `;
    document.head.appendChild(style);
  }

  function buildPopup(cfg) {
    injectStyles();

    const overlay = document.createElement('div');
    overlay.id = 'eut-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    overlay.innerHTML = `
      <div id="eut-popup-card">
        <button id="eut-popup-close" aria-label="Fermer">✕</button>
        ${cfg.image_url ? (() => {
          const mode = cfg.beauty_club_title_mode || 'star_title';
          let badge = '';
          if (mode === 'star_title') badge = `<div id="eut-popup-img-badge"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 113.4" aria-hidden="true"><path d="M29.5 113.4C27.7 61.5 26.3 58.8 0 55.3 26.2 51.8 27.7 49 29.5 0c1.8 48.9 3.3 51.8 29.5 55.3-26.3 3.5-27.7 6.2-29.5 58.1Z" fill="currentColor"/></svg><span>Beauty Club</span></div>`;
          else if (mode === 'title') badge = `<div id="eut-popup-img-badge"><span>Beauty Club</span></div>`;
          return `<div id="eut-popup-img-wrap"><img id="eut-popup-img" src="${cfg.image_url}" alt="" loading="lazy">${badge}</div>`;
        })() : ''}
        <div id="eut-popup-body">
          <div id="eut-popup-title">${cfg.title}</div>
          <div id="eut-popup-subtitle">${cfg.subtitle}</div>
          ${cfg.capture_email ? `
            <form id="eut-popup-form" novalidate>
              <input id="eut-popup-email" type="email" name="email" required autocomplete="email" inputmode="email" placeholder="ton@email.com" aria-label="Ton adresse email">
              <button id="eut-popup-submit" type="submit">${cfg.button_text}</button>
              <div id="eut-popup-error" role="alert" aria-live="polite"></div>
              <div id="eut-popup-consent">${cfg.consent_text || ''}</div>
            </form>
          ` : `<a id="eut-popup-cta" href="${cfg.button_url}">${cfg.button_text}</a>`}
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    trackEvent('impression');

    function close() {
      overlay.style.animation = 'eut-fade-in 0.2s ease reverse';
      setTimeout(() => overlay.remove(), 200);
    }

    // X : ferme pour cette session seulement, réapparaîtra à la prochaine visite
    document.getElementById('eut-popup-close').addEventListener('click', () => {
      trackEvent('dismiss');
      markSessionDismiss();
      close();
    });

    // Clic sur le fond
    overlay.addEventListener('click', e => {
      if (e.target === overlay) {
        trackEvent('dismiss');
        markSessionDismiss();
        close();
      }
    });

    // Touche Échap
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') {
        trackEvent('dismiss');
        markSessionDismiss();
        close();
        document.removeEventListener('keydown', onKey);
      }
    });

    if (cfg.capture_email) {
      // Mode inscription : le bouton EST le consentement (but annoncé + action positive)
      const form  = document.getElementById('eut-popup-form');
      const input = document.getElementById('eut-popup-email');
      const btn   = document.getElementById('eut-popup-submit');
      const err   = document.getElementById('eut-popup-error');

      function showSuccess() {
        document.getElementById('eut-popup-body').innerHTML = `
          <div id="eut-popup-title">${cfg.success_title || 'Bienvenue ✨'}</div>
          <div id="eut-popup-subtitle">${cfg.success_subtitle || ''}</div>
          <button id="eut-popup-cta" type="button">Continuer mes achats →</button>
        `;
        // On NE redirige PAS : la cliente reste sur sa page (souvent un produit).
        // Le bouton referme juste la popup, elle poursuit son achat.
        document.getElementById('eut-popup-cta').addEventListener('click', close);
        setTimeout(close, 4000);
      }

      form.addEventListener('submit', async e => {
        e.preventDefault();
        const email = input.value.trim();
        err.textContent = '';
        input.removeAttribute('aria-invalid');
        if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(email)) {
          err.textContent = 'Vérifie ton adresse email.';
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        const label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Un instant…';
        try {
          const r = await fetch(API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              mode: 'subscribe',
              email,
              popup_id: POPUP_ID,
              session_id: getSessionId(),
              shopify_customer_id: window.__st?.cid ? String(window.__st.cid) : null,
              page_url: location.pathname,
            }),
          });
          const d = await r.json().catch(() => ({}));
          if (!r.ok || d.error) throw new Error(d.error || 'erreur');
          markAttribution();
          markJoined();   // inscrite → on ne la relance plus jamais
          showSuccess();
        } catch (_) {
          btn.disabled = false;
          btn.textContent = label;
          err.textContent = 'Oups, réessaie dans un instant.';
        }
      });
    } else {
      // Mode lien : marque comme inscrit → plus jamais de popup
      document.getElementById('eut-popup-cta').addEventListener('click', () => {
        trackEvent('click');
        markAttribution();
        markJoined();
      });
    }
  }

  async function init() {
    if (!DEBUG_POPUP) {
      if (hasJoined()) return;
      if (dismissedThisSession()) return;
    }

    try {
      const res = await fetch(API, { cache: 'no-store' });
      if (!res.ok) return;
      const cfg = await res.json();
      if (!cfg) return;
      if (!DEBUG_POPUP && !cfg.enabled) return;
      POPUP_ID = cfg.id ?? null;

      const delay = DEBUG_POPUP ? 0 : Math.max(0, (cfg.delay_seconds ?? 20)) * 1000;
      setTimeout(() => buildPopup(cfg), delay);
    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();